import React,{useEffect, useState} from 'react'
import Pitch from '../../Pitch'
import { IPlayerAttributesData } from '../../../types/IPlayerAttributesData'
import { AttributesTable } from '../Attributes/AttributesTable'
import { useSearch } from '../../../contexts/PlayerSearchContext'
import { postData } from '../../../services/api'
import apiUrls from '../../../config/apiUrls'
import IApiResponse from '../../../types/IApiResponse'
import handleApiResponse from '../../../utils/handleApiResponse'
import { useLoaderData } from 'react-router-dom'
import { useLoading } from '../../../contexts/LoadingContext'
import { ModuleSpinner } from "../../../ui/LoadingSpinner/ModuleSpinner";
import InfoIcon from "../../../assets/icons/info-icon.svg"
import LabelText from '../../../ui/LabelText'
import HighlyEffectiveIcon from '../../../assets/icons/highly-effective.png';
import EffectiveIcon from '../../../assets/icons/effective.png';
import avgIcon from '../../../assets/icons/avg.png';
import BelowAvgIcon from '../../../assets/icons/below-avg.png'
import LabelNumber from '../../../styled-components/LabelNumber'
import DirectionIcon from '../../../assets/icons/direction.svg'
import CloseIcon from '@mui/icons-material/Close';
import HighlyEffectiveSign from '../../../assets/icons/highly-effectiveSign.png';
import EffectiveSign from '../../../assets/icons/effectiveSign.png';
import avgSign from '../../../assets/icons/avgSign.png';
import BelowAvgSign from '../../../assets/icons/below-avgSign.png';
import SuccessfullIcon from '../../../assets/icons/successfullIcon.png'
import UnSuccessfullIcon from '../../../assets/icons/unsuccessfullIcon.png'
import AttributeDirectionIcon from '../../../assets/icons/attribute-direction.svg'
import SecondaryButton from '../../../ui/SecondaryButton'

interface IAttributesOnPitch{
    attributesData : IPlayerAttributesData,
    playerId: number,
    seasonId: number
}

export interface IFinalThirdPitchData{
    locationX:number,
    locationY: number,
    score:number,
    dateTime:string,
    matchLabel:string
}

export interface IDefencePitchData{
    playerId: number,
    avgX:number,
    avgY: number,
    outerHull: [
        {
            locationX: number,
            locationY: number,
            isSuccessFul: boolean
        },
    ],
    innerHull: [
        {
            locationX: number,
            locationY: number,
            isSuccessFul: boolean
        },
       
    ]
}
export interface IBuildupPlayOnPitchData{
    locationX:number,
    locationY: number,
    score:number,
    count: number,
    matchPeriod: null,
    passAngle: number,
    passLength: number,
    opponentTeamName: null,
    timestampSeconds: null,
    dateTime:string,
    matchLabel:string
}

const AttributesOnPitch: React.FC<IAttributesOnPitch> = ({attributesData , playerId , seasonId}) => {

    const [selectedPosition, setSelectedPosition] = useState<"theirposition" | "allpositions">("allpositions");
    const {selectedAttr , setSelectedAttr , attrDescription , attrInfoLabel ,isInfocard, setIsInfoCard} = useSearch();
    const {startLoading, stopLoading} = useLoading();
    const [finalThirdData , setFinalThirdData] = useState<IFinalThirdPitchData[]>()
    const [defenceData , setDefenceData] = useState<IDefencePitchData>()
    const [buildupPlayData , setBuildUpPlayData] = useState<IBuildupPlayOnPitchData[]>()
    const [isAttributesLoading, setIsAttributesLoading] = useState<boolean>(false);
    const [animateOut, setAnimateOut] = useState(false);       // handle exit animation

    const handleShowCard = () => {
      setIsInfoCard(true);       // show + mount
      setAnimateOut(false);      // reset animation
    };

    const handleHideCard = () => {
      setAnimateOut(true);       // trigger slide-out
      setTimeout(() => {
        setIsInfoCard(false);    // unmount after animation ends
      }, 400); // Match CSS duration
    };
        

    useEffect(()=>{
      const fetchFinalThirdAttributesData = async () => {
            try {
              setIsAttributesLoading(true);
              const ApiRequestData = {
                  playerId:playerId,
                  seasonId:seasonId,
                  attributeName:selectedAttr
              }
              const response: IApiResponse<IFinalThirdPitchData[]> = await postData(apiUrls.PlayerFinalThird, ApiRequestData);
              handleApiResponse(
                response,
                (attributesData) => {
                  setFinalThirdData(attributesData);
                  setIsAttributesLoading(false);
                },
                (error) => {
                  console.error(error);
                  setIsAttributesLoading(false);
                }
              );
            } catch (error) {
              setIsAttributesLoading(false);
              console.error("Error fetching PlayerFinalThird data:", error);
            }
        };
        const fetchBuildUpPlayAttributesData = async () => {
            try {
              setIsAttributesLoading(true);
              const ApiRequestData = {
                  playerId:playerId,
                  seasonId:seasonId,
                  attributeName:selectedAttr
              }
              const response: IApiResponse<IBuildupPlayOnPitchData[]> = await postData(apiUrls.PlayerBuildUpPlay, ApiRequestData);
              handleApiResponse(
                response,
                (attributesData) => {
                  setBuildUpPlayData(attributesData);
                  setIsAttributesLoading(false);
                },
                (error) => {
                  console.error(error);
                  setIsAttributesLoading(false);
                }
              );
            } catch (error) {
              setIsAttributesLoading(false);
              console.error("Error fetching PlayerBuildUpPlay data:", error);
            }
        };
        const fetchDefensiveAttributesData = async () => {
            try {
              setIsAttributesLoading(true);
              const ApiRequestData = {
                  playerId:playerId,
                  seasonId:seasonId,
                  attributeName:selectedAttr
              }
              const response: IApiResponse<IDefencePitchData> = await postData(apiUrls.PlayerDefensive, ApiRequestData);
              handleApiResponse(
                response,
                (attributesData) => {
                  setDefenceData(attributesData);
                  setIsAttributesLoading(false);
                },
                (error) => {
                  console.error(error);
                  setIsAttributesLoading(false);
                }
              );
            } catch (error) {
              setIsAttributesLoading(false);
              console.error("Error fetching PlayerDefensive data:", error);
            }
        };
             
        if(selectedAttr === 'Finishing - Shots' || selectedAttr === 'Finishing - Aerial' || selectedAttr === 'Attack positioning'){
            fetchFinalThirdAttributesData();
        }
        else if(selectedAttr === 'Creativity' || selectedAttr === 'Passing accuracy' || selectedAttr === 'Dribbling' || selectedAttr === 'Crossing'){
            fetchBuildUpPlayAttributesData();
        }
        else{
            fetchDefensiveAttributesData();
        }
    },[playerId,seasonId,selectedAttr])

  return (
    <>
        <div className='On-pitch-container'>
        <div style={{width:'1058px',height:'636px',alignSelf:'center',position:'relative'}}>
            <Pitch
                currentView='attributesOnPitch'
                finalThirdData={finalThirdData}
                buildupPlayData = {buildupPlayData}
                defenceData={defenceData}
            />
           
            <div className='attributesonpitch-info-icon'>
                <img src={InfoIcon} width={24} height={24} onClick={()=>{handleShowCard()}} style={{cursor:'pointer'}}/>
                
            </div>
            <img src={AttributeDirectionIcon}  width={121} height={24} className='direction-pitch-icon'/>
            {isInfocard && (
              <div className={`attributesonpitch-info-card ${animateOut ? 'slide-out' : 'slide-in'}`}>
                  <div style={{alignItems:'stretch',borderBottom:'1px solid #DADADA'}} className='onpitch-info-label'>
                      <LabelText className='player-detail-given-name'>{selectedAttr}</LabelText>
                      <CloseIcon sx={{color:'#7C7D79',cursor:'pointer'}} onClick={()=>{handleHideCard()}}/>
                  </div>
                  <div className='color-info-content'><img src={DirectionIcon}/><LabelNumber className='percentile-text'>Direction of play</LabelNumber></div>
                  <div className='onpitch-card-container'>
                        <LabelText className='secondary-cta-text'>{attrInfoLabel}</LabelText>
                  {attrInfoLabel === 'Defensive hull' && (<LabelText className='small'>The coloured patch represents the area the player has good degree of defensive control over.</LabelText>)}

                        <LabelText className='small'>{attrDescription}</LabelText>
                  </div>
                  {attrInfoLabel === 'Heat signature' && (<LabelText className='small'>The colour represents effectiveness:</LabelText>)}
                  <div className='color-info-container'>
                      {attrInfoLabel === 'Defensive hull' ? (
                        <>
                          <div className='color-info-content'><img src={SuccessfullIcon}/><LabelText className='small'>Successful</LabelText></div>
                          <div className='color-info-content'><img src={UnSuccessfullIcon}/><LabelText className='small'>Unsuccessful </LabelText></div>
                        </>
                      ):(
                        <>
                          <div className='color-info-content'><img src={attrInfoLabel === 'Heat signature' ?  HighlyEffectiveSign : HighlyEffectiveIcon}/><LabelText className='small'>Highly effective</LabelText></div>
                          <div className='color-info-content'><img src={attrInfoLabel === 'Heat signature' ?  EffectiveSign : EffectiveIcon}/><LabelText className='small'>Effective</LabelText></div>
                          <div className='color-info-content'><img src={attrInfoLabel === 'Heat signature' ?  avgSign : avgIcon}/><LabelText className='small'>Average</LabelText></div>
                          <div className='color-info-content'><img src={attrInfoLabel === 'Heat signature' ?  BelowAvgSign : BelowAvgIcon}/><LabelText className='small'>Below average</LabelText></div>
                        </>
                      )}
                       
                  </div>
                  {attrInfoLabel === 'Heat signature' && (<LabelText className='small'>Colour intensity represents how much a player performs the relevant actions in a given area.</LabelText>)}
              </div>
            )}
            {isAttributesLoading && <ModuleSpinner />} 
            
        </div>
        <AttributesTable selectedPosition={selectedPosition} setSelectedPosition={setSelectedPosition}  attributesData={attributesData} playerId={playerId}/>
      </div>
      {/* <AttributesTable selectedPosition={selectedPosition} setSelectedPosition={setSelectedPosition}  attributesData={attributesData} playerId={playerId} ifForTeam={true}/> */}
    </>

  )
}

export default AttributesOnPitch